import React from 'react';
import './Disclaimer.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import createLink from '../../../libs/createLink';
import { DisableBodyScroll } from '../../../hooks/useDisableBodyScroll';

const TextRotator = ({ texts, interval = 3000 }) => {
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [maxWidth, setMaxWidth] = React.useState(0);
    const [isAnimating, setIsAnimating] = React.useState(false);
    const textRef = React.useRef(null);
    
    React.useEffect(() => {
        // Trouver la largeur maximale parmi tous les textes
        let maxTextWidth = 0;
        const tempSpan = document.createElement('span');
        tempSpan.className = 'rotating-text';
        tempSpan.style.visibility = 'hidden';
        tempSpan.style.position = 'absolute';
        document.body.appendChild(tempSpan);
        
        texts.forEach(text => {
            tempSpan.textContent = text;
            const width = tempSpan.offsetWidth;
            maxTextWidth = Math.max(maxTextWidth, width);
        });
        
        document.body.removeChild(tempSpan);
        setMaxWidth(maxTextWidth);
        
        // Mettre en place l'intervalle pour la rotation
        const timer = setInterval(() => {
            setIsAnimating(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
                setIsAnimating(false);
            }, 300); // Durée de l'animation de sortie
        }, interval);
        
        return () => clearInterval(timer);
    }, [texts, interval]);
    
    return (
        <span 
            className={`rotating-text ${isAnimating ? 'rotating-out' : 'rotating-in'}`} 
            ref={textRef} 
            style={{ 
                minWidth: `${maxWidth}px`, 
                // textAlign: 'center',
                display: 'inline-block',
                transition: 'opacity 0.3s, transform 0.3s',
                opacity: isAnimating ? 0 : 1,
                transform: isAnimating ? 'translateY(-8px)' : 'translateY(0)'
            }}
        >
            {texts[currentIndex]}
        </span>
    );
};

const textsHot = [
    'Caliente', 'Olé-Olé', '18+', 'Chaud', 'Hot', 'Hum-hum', 'Séduisant', 'Libertin', 'Classé X',
    'Torride', 'Érotique', 'Coquin', 'Épicé', 'Spicy', 'Bouillant',
    'Sensuel', 'Coquin', 'Piquant',
    'Brûlant',
    'Osé', 'Boom-boom', 'XOXO', 'Pimenté',
    'Sulfureux', 'XXX', 'Ardent', 'Passionné', 'Fiévreux', 'Enflammé',
    'Allumé', 'Provocant', 'Sans filtre', 'Suggestif', 'Chaud bouillant',
    'Affriolant', 'Aphrodisiaque', 'Aguichant', 'Audacieux', 'Tentant',
    'Excitant', 'Voluptueux', 'Intense', 'Indiscret', 'Endiablé',
    'Frisson', 'Chaleureux', 'Fou-fou', 'Délicieux', 'Torrid', 'Fou', 'Crazy',
    'Fougueux', 'Débridé', 'Déchaîné', 'Détonnant', 'Électrisant'
]

const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};

const shuffledTextsHot = shuffleArray(textsHot);

function closeCurrentWindow() {
    const referrer = document.referrer;
    const currentHost = window.location.hostname;

    const hasReferrer = !!referrer;
    const isExternalReferrer = hasReferrer && new URL(referrer).hostname !== currentHost;

    if (isExternalReferrer && window.history.length > 1) {
        window.history.back();
    } else {
        window.location.href = 'https://www.google.com';
    }
}

const Disclaimer = ({initialized, disclaim}) => {
    return (
        <div className="disclaimer-container">
            <DisableBodyScroll/>
            <div className="disclaimer">
                <h1><b>Voissa</b> est un <b>réseau social</b> pour ceux qui n’ont <b>rien à cacher.</b> 🥵🔥</h1>
                <p>Voissa étant <b><TextRotator texts={shuffledTextsHot.map(txt=>`“${txt}”`)} interval={1200}/></b><br/>Ce site est<b> exclusivement réservé aux adultes.</b></p>
                <div className="disclaimer-footer">
                    <button className={classNames("disclaimer-button", {disabled : !initialized})} onClick={()=>disclaim()}>J’ai l’âge, go 😈</button>
                    <button className="quit" onClick={()=>closeCurrentWindow()}>Sortir</button>
                    <ul>
                        <li><Link to={createLink('cgus')}>mentions légales</Link></li>
                        <li><Link to={createLink('parentalControl')}>contrôle parental</Link></li>
                        <li><Link to={createLink('contact')}>contact</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}   

export default Disclaimer;